import PageWrapper from '@/components/page-wrapper'
import Banner from './banner'
import Advantage from './advantage'
import Enable from './enable'
import Work from './work'
import SafeReliable from './safe-reliable'
import Contact from './contact'

export default function DisasterRelief() {
  return (
    <PageWrapper soul>
      <Banner />
      <Advantage />
      <Enable />
      <Work />
      <SafeReliable />
      <Contact />
    </PageWrapper>
  )
}
